import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import cn from 'classnames';

import ActionButton from 'components/widgets/ActionButton/ActionButton';
import Languages from 'components/widgets/LanguagesDropDown/LanguagesDropDown';

import { useDownloadPage } from './hooks/useDownloadPage';

import styles from './DownloadPageChecker.module.scss';

function DownloadPageChecker({ children }: { children: JSX.Element }) {
  const intl = useIntl();
  const buttonLabel = intl.formatMessage({ id: 'Download.linkTo', defaultMessage: 'Download App' });
  const titleLabel = intl.formatMessage({ id: 'Download.headline', defaultMessage: "It's Better In The App" });
  const descriptionLabel = intl.formatMessage({ id: 'Download.descriptio', defaultMessage: 'Download our mobile app to watch your favorite content and for the best experience' });
  const {
    to,
    isChangingLangEnabled,
    isAppDownloadRequired,
    isAutoRedirect,
    actionFrameIconUrl,
    bannerUrl,
    handleRef,
    isTablet,
  } = useDownloadPage();

  useEffect(() => {
    if (isAutoRedirect) {
      window.location.href = to!;
    }
  }, [isAutoRedirect]);

  if (!isAppDownloadRequired) {
    return children;
  }

  return (
    // eslint-disable-next-line css-modules/no-undef-class
    <div ref={handleRef} className={cn(styles.container, { [styles.noImage]: !bannerUrl, [styles.tablet]: isTablet })}>
      <div className={styles.languages}>{isChangingLangEnabled && <Languages />}</div>
      <div className={styles.actionFrame}>
        {actionFrameIconUrl && (
          <img className={styles.actionFrameIcon} src={actionFrameIconUrl} alt='actionFrameIcon' />
        )}
        <h1 className={styles.headline}>
          {titleLabel}
        </h1>
        <p className={styles.descrption}>
          {descriptionLabel}
        </p>
        <ActionButton title={buttonLabel} className={styles.linkTo} to={to} />
      </div>
      {bannerUrl && <img className={styles.banner} src={bannerUrl} alt='banner' />}
    </div>
  );
}

export default DownloadPageChecker;
